import HandshakeIcon from '@mui/icons-material/Handshake';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import { Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import makeStyles from '@mui/styles/makeStyles';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useCurrentUser } from '@/contexts/CurrentUserContext';
import {
  FEATURE_NOT_AVAILABLE_TOOLTIP,
  M_A_OPPORTUNITIES_TABLE_PATH,
  M_A_TRANSACTIONS_OVERVIEW_PATH,
} from '@/utils/constants';

const useStyles = makeStyles(theme => ({
  button: {
    ...theme.palette.button,
  },
}));

export default () => {
  const classes = useStyles();
  const { isUserEntitled } = useCurrentUser();

  return (
    <Grid container spacing={2} size={12}>
      <Grid size={2} />
      <Grid container spacing={2} size={8}>
        <Grid>
          <Tooltip
            title={
              isUserEntitled(M_A_TRANSACTIONS_OVERVIEW_PATH)
                ? 'Merger & Acquisitions Transactions'
                : FEATURE_NOT_AVAILABLE_TOOLTIP
            }
          >
            <span>
              <Button
                component={Link}
                to={M_A_TRANSACTIONS_OVERVIEW_PATH}
                variant='contained'
                className={classes.button}
                underline='none'
                disabled={!isUserEntitled(M_A_TRANSACTIONS_OVERVIEW_PATH)}
              >
                <WorkOutlineIcon fontSize='small' />
                &nbsp;M&A Analytics
              </Button>
            </span>
          </Tooltip>
        </Grid>
        <Grid>
          <Tooltip
            title={
              isUserEntitled(M_A_OPPORTUNITIES_TABLE_PATH)
                ? 'Merger & Acquisitions Opportunities'
                : FEATURE_NOT_AVAILABLE_TOOLTIP
            }
          >
            <span>
              <Button
                component={Link}
                to={M_A_OPPORTUNITIES_TABLE_PATH}
                variant='contained'
                className={classes.button}
                underline='none'
                disabled={!isUserEntitled(M_A_OPPORTUNITIES_TABLE_PATH)}
              >
                <HandshakeIcon fontSize='small' />
                &nbsp;M&A Opportunities
              </Button>
            </span>
          </Tooltip>
        </Grid>
        <Grid>
          <Button
            variant='contained'
            className={classes.button}
            onClick={() =>
              window.open(
                'https://welligence.com/intelligence/?_post_content=ma&_category=deep-dives',
                '_blank',
              )
            }
          >
            <LibraryBooksIcon fontSize='small' />
            &nbsp;m&a reports
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};
